export default {
  apiUrl: 'http://yoursite.com/api/',
};

const siteConfig = {
  siteName: 'Swasth for Clinicians',
  siteIcon: 'ion-flash',
  footerText: `Swasth ©${new Date().getFullYear()}`,
};
const themeConfig = {
  topbar: 'themedefault',
  sidebar: 'themedefault',
  layout: 'themedefault',
  theme: 'themedefault',
};

const stripeKeys = {
  dev: 'pk_test_Wr3QbJQOcpPJhcjb2bvWJNsx',
  prod: 'pk_live_ajUp3JoEEnkkeJqICtPwYtUG'
}
const language = 'english';
export {
  siteConfig,
  language,
  themeConfig,
  stripeKeys
};
